import { render, staticRenderFns } from "./EducationalGroupDelete.vue?vue&type=template&id=5d602203&"
import script from "./EducationalGroupDelete.vue?vue&type=script&lang=js&"
export * from "./EducationalGroupDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports